<template>
  <div :id="anchorId" class="relative scroll-mt-8 lg:scroll-mt-16">
    <NuxtErrorBoundary @error="handleError">
      <component :is="component" v-if="component" v-bind="block.value" />
    </NuxtErrorBoundary>
  </div>
</template>

<script setup lang="ts">
import type { PageBlockApiModel } from '@gro-up/api/corporate'
import { computed } from 'vue'

import { useComponentMappers } from '../../composables/useComponentMappers'
import { getBlockAnchorId } from '../../utils/block-anchor'

const props = defineProps<{
  block: PageBlockApiModel
}>()

const { getBlockComponent } = useComponentMappers()

const anchorId = computed(() => getBlockAnchorId(props.block))

// Resolved once per block type rather than inline in the template: `getBlockComponent` hands back
// a fresh `defineAsyncComponent` wrapper on every call, and a new component identity on `:is`
// remounts the whole subtree on each re-render.
const component = computed(() => getBlockComponent(props.block.type))

const handleError = (error: unknown) => {
  console.error(`Failed to render block of type '${props.block.type}'`, {
    error,
    block: props.block,
  })
}
</script>
